import { Center, Spinner } from '@chakra-ui/react'
import React, { lazy, Suspense } from 'react'
import { Helmet } from 'react-helmet-async'
import type { ViewableParentSuccessResponse } from '../../interfaces'
import type { FileDetailsResponse } from '../../interfaces/FileDetailsResponse'

const FileDetailLayout = lazy(
  () => import('../../layouts/MediaLibrary/FileDetailLayout'),
)

const FallbackSpinner = () => (
  <Center height="100%">
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="appPaleGrey"
      color="appBlue"
      size="xl"
    />
  </Center>
)

const FileDetailPage = ({
  fileDetails,
  loading,
  viewableParent,
  toggleTagsModal,
  getFileDetails,
  onOpenShareModal,
}: {
  fileDetails: FileDetailsResponse | undefined
  loading: boolean
  viewableParent: ViewableParentSuccessResponse | undefined
  toggleTagsModal(isTagsModalOpen: boolean): void
  getFileDetails(): Promise<FileDetailsResponse>
  onOpenShareModal(): void
}): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>{fileDetails?.name ?? 'File Detail'}</title>
      <meta name="description" content="File Detail page" />
    </Helmet>
    {fileDetails ? (
      <Suspense fallback={<FallbackSpinner />}>
        <FileDetailLayout
          fileDetails={fileDetails}
          toggleTagsModal={toggleTagsModal}
          getFileDetails={getFileDetails}
          loading={loading}
          viewableParent={viewableParent}
          onOpenShareModal={onOpenShareModal}
        />
      </Suspense>
    ) : (
      <FallbackSpinner />
    )}
  </React.Fragment>
)

export default FileDetailPage
